module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('router-link', {
    staticClass: "fl-button",
    attrs: {
      "to": {
        path: '/user/edit/'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('h1', [_vm._v("Felhasználók")]), _vm._v(" "), _c('div', {
    staticClass: "table-with-title"
  }, [_c('h2', [_vm._v("Felhasználók")]), _vm._v(" "), _c('table', {
    staticClass: "list"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', {
      staticClass: "buttons"
    }, [_c('router-link', {
      staticClass: "small-button",
      attrs: {
        "to": {
          path: '/user/edit/',
          query: {
            userID: user.element_id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-alt"
    })]), _vm._v(" "), _c('a', {
      staticClass: "small-button",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.del(user.element_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-alt"
    })])], 1)])
  }), 0)])])])])], 1), _vm._v(" "), _c('HTMLFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Név")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07a13b6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/users.vue
// module id = 280
// module chunks = 0